import React from 'react'
import { Input } from 'antd'
import _ from 'lodash'

const DefaultFilter = ({ column, handleFilter }) => {
  return (
    <Input
      autoComplete='none'
      size='small'
      onChange={(e) => handleInputChange(column, e.target.value, handleFilter)}
      value={column.filterValue || column.finalFilterValue}
      onPressEnter={() => handleFilter(column, 'default')}
    />
  )
}

const handleInputChange = (column, value, handleFilter) => {
  // If there were no previous values and the user types only space, we ignore that
  if (!column.filterValue && !value.trim()) {
    return
  }

  column.filterValue = !value.trim() ? '' : value

  if (!column.filterValue) {
    handleFilter(column, 'default')
  }

  if (!column.filterOnSubmit) {
    column.finalFilterValue = !value.trim() ? '' : value
  }
}

const FilteringMethod = (value, query) => {
  if (!_.isUndefined(value) && !_.isNull(value)) {
    const parsedValue = value
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase()
      .trim()

    const parsedQuery = query
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase()
      .trim()

    if (parsedQuery.includes('||')) {
      return parsedQuery.split('||').some((pv) => pv.trim() && parsedValue.includes(pv.trim()))
    } else if (parsedValue.includes(parsedQuery)) {
      return true
    }
  }

  return false
}

export { DefaultFilter, FilteringMethod }
